/*
 * 1DS JS SDK Privacy Guard plugin, 4.3.5
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* PrivacyConcernMetadataProvider.ts
* @author Manuel Lopez (manuellopez)
* @copyright Microsoft 2024
* Class implementing the PrivacyConcernMetadataProvider for PrivacyGuardPlugin
*/
import dynamicProto from "@microsoft/dynamicproto-js";
var PrivacyConcernMetadataProvider = /** @class */ (function () {
    function PrivacyConcernMetadataProvider() {
        this.GetShouldIgnoreOverride = function (telemetryItem) {
            return null;
        };
        dynamicProto(PrivacyConcernMetadataProvider, this, function (_self) {
            _self.GetDatabaseName = function (telemetryItem) {
                return "";
            };
            _self.GetServerName = function (telemetryItem) {
                return "";
            };
            _self.GetEventLocatorName = function (telemetryItem) {
                return "";
            };
            _self.GetEventLocatorValue = function (telemetryItem) {
                return "";
            };
            _self.GetPrivacyGuardEventTimeOverride = function (telemetryItem) {
                return "";
            };
            _self.GetShouldIgnoreOverride = function (telemetryItem) {
                return false;
            };
            _self.GetIsContext = function (telemetryItem) {
                return false;
            };
            _self.GetIsGlobalContext = function (telemetryItem) {
                return false;
            };
            _self.GetAssociatedTenant = function (telemetryItem) {
                return "";
            };
            _self.GetEnvironment = function (telemetryItem) {
                return "";
            };
            _self.GetMetadata = function (telemetryItem) {
                return "";
            };
            _self.GetPrivacyConcernEvent = function (concernEventName, tableName, columnName, concernTypeText, eventTime, telemetryItem) {
                var event = _self.GetPrivacyGuardEventTimeOverride(telemetryItem);
                if (event === "") {
                    event = eventTime;
                }
                return {
                    PG_ConcernEventName: concernEventName,
                    PG_TableName: tableName,
                    PG_ColumnName: columnName,
                    PG_ConcernTypeText: concernTypeText,
                    PG_EventTime: event,
                    PG_ShouldIgnore: _self.GetShouldIgnoreOverride(telemetryItem),
                    PG_ServerName: _self.GetServerName(telemetryItem),
                    PG_DatabaseName: _self.GetDatabaseName(telemetryItem),
                    PG_EventLocatorName: _self.GetEventLocatorName(telemetryItem),
                    PG_EventLocatorValue: _self.GetEventLocatorValue(telemetryItem),
                    PG_IsContext: _self.GetIsContext(telemetryItem),
                    PG_IsGlobalContext: _self.GetIsGlobalContext(telemetryItem),
                    PG_AssociatedTenant: _self.GetAssociatedTenant(telemetryItem),
                    PG_Environment: _self.GetEnvironment(telemetryItem),
                    PG_Metadata: _self.GetMetadata(telemetryItem)
                };
            };
        });
    }
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetDatabaseName.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetServerName.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetEventLocatorName.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetEventLocatorValue.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetPrivacyGuardEventTimeOverride.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetIsContext.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetIsGlobalContext.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetAssociatedTenant.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetEnvironment.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetMetadata.
// Removed Stub for PrivacyConcernMetadataProvider.prototype.GetPrivacyConcernEvent.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PrivacyConcernMetadataProvider.__ieDyn=1;

    return PrivacyConcernMetadataProvider;
}());
export { PrivacyConcernMetadataProvider };
//# sourceMappingURL=PrivacyConcernMetadataProvider.js.map